var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollapse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 21C21 21.4142 20.6642 21.75 20.25 21.75C19.8358 21.75 19.5 21.4142 19.5 21L19.5 3C19.5 2.58579 19.8358 2.25 20.25 2.25C20.6642 2.25 21 2.58579 21 3V21ZM12.2197 17.0303C11.9268 16.7374 11.9268 16.2626 12.2197 15.9697L15.4393 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H15.4393L12.2197 8.03033C11.9268 7.73744 11.9268 7.26256 12.2197 6.96967C12.5126 6.67678 12.9874 6.67678 13.2803 6.96967L17.7803 11.4697C18.0732 11.7626 18.0732 12.2374 17.7803 12.5303L13.2803 17.0303C12.9874 17.3232 12.5126 17.3232 12.2197 17.0303Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse.db499eb9cf37cfbaa1e5c71bd77deef5.svg";